import SkeletonBase from "newui/components/Skeleton";

interface InitialEvaluationStepProps {
	rfxId: number;
	rfxSubmissionId?: number;
	isLoading?: boolean;
}

export const InitialEvaluationStep: React.FC<InitialEvaluationStepProps> = ({
	rfxId,
	rfxSubmissionId,
	isLoading = false,
}) => {
	if (isLoading) {
		return (
			<div className="space-y-3">
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
			</div>
		);
	}

	return (
		<div data-testid="initial-evaluation-step">
			<p className="text-sm text-gray-500 mb-4">
				Score each supplier against the evaluation criteria you defined.
			</p>
			{/* TODO: Render initial scoring interface when API is available */}
			<div className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-gray-400 text-sm">
				Supplier scoring grid will appear here.
			</div>
		</div>
	);
};
